export enum AppRoutes {
  OctwRules = '/',
  Capacity = '/capacity',
  CapacityId = '/capacity/:id',
  Users = '/users/:id',
  GlobalUsers = '/global-users',
  CalendarId = '/calendar/:id',
  WeatherId = '/weather/:id',
}
